exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-account-components-BankAccount-___style__loadContainer___16ISG{text-align:center;margin:1rem;background-color:#fff;border:1px solid #e5e3e3;padding:1rem}.web-flows-account-components-BankAccount-___style__bank___Z2bjT{margin:1rem;display:flex;background-color:#fff;border:1px solid #e5e3e3;padding:.5rem 1.5em}.web-flows-account-components-BankAccount-___style__detail___2npiu{font-weight:700;flex-grow:1}.web-flows-account-components-BankAccount-___style__detail___2npiu>span{font-weight:400}", ""]);

// exports
exports.locals = {
	"loadContainer": "web-flows-account-components-BankAccount-___style__loadContainer___16ISG",
	"bank": "web-flows-account-components-BankAccount-___style__bank___Z2bjT",
	"detail": "web-flows-account-components-BankAccount-___style__detail___2npiu"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/account/components/BankAccount/style.css
// module id = 1334
// module chunks = 0